import styled from 'styled-components';
import { breakpoints } from 'assets/breakpoints';

export const StyledButton = styled.a`
  padding: 10px;
  background:linear-gradient(#ed1c24,#b01218);
  width: calc(100% - 20px);
  margin: 10px 0;
  cursor: pointer;
  font-weight: bold;
  font-size: 16px;
  ${(props) => props.secondary && 'background:linear-gradient(#3f3f3f,#5e5e5e);'};
  
  @media (min-width: ${breakpoints.desktop}) {
    background:linear-gradient(#982828,#4d1718);
    border-radius: 5px;
    width: 100px;
    font-weight: normal;
    font-size: 14px;
  }
`;

export const ButtonText = styled.p`
  color: white;
  margin: 0;
  text-align: center;
  font-weight: normal;
`;
